$(function () {
    $('.wizard-form').keypress(function (e) {
        if (e.which == 13) {
            $('#button-continue').click();
            e.preventDefault();
        }
    })
});

function update_organization(el$) {
    if (el$.val() === 'OM') {
        $('#div_id_profile-organization_name').hide();
        $('#div_id_profile-omcl').show();
        $('#id_profile-organization_name').val(undefined);
        $('#id_profile-access_level option[value="AD"]').attr('disabled', false);
    } else {
        $('#div_id_profile-omcl').hide();
        $('#id_profile-omcl').val(null).trigger('change');
        $('#div_id_profile-organization_name').show();
        if (el$.val() === 'ED') {
            $('#id_profile-organization_name').val('EDQM');
            $('#id_profile-access_level option[value="AD"]').attr('disabled', false);
        } else if (el$.val() === 'OH') {
            $('#id_profile-access_level option[value="AD"]').attr('disabled', false);
        } else {
            $('#id_profile-access_level option[value="AD"]').attr('disabled', true).attr('selected', false);
        }
    }
}

let organization_type$ = $('#id_profile-organization_type');
update_organization(organization_type$);
organization_type$.on('change', function(e) {
    update_organization($(this));
});
$('#id_profile-omcl').on('change', function(e) {
   $('#id_profile-organization_name').val($(this).find('option:selected').text());
});